export const PhoneRegex = /^\+1 \(\d{3}\) \d{3}-\d{4}$/;
export const PasswordRegex =
  /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$|^.{15,}$/g;
